<template>
  <el-dialog :title="editFormTitle" :visible.sync="visible" width="600px" center :close-on-click-modal="false">
    <el-form :model="editForm">
      <el-form-item label="患者姓名" :label-width="formLabelWidth">
        <el-input v-model="editForm.name" style="width: 240px" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="患者手机号" :label-width="formLabelWidth">
        <el-input v-model="editForm.tel" style="width: 240px" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="选择护工" :label-width="formLabelWidth">
        <el-select v-model="editForm.nurse_id" allow-create filterable default-first-option placeholder="请选择护工"
                   style="width: 240px">
          <el-option
            v-for="hospital in nurses"
            :label="`${hospital.name}/${hospital.tel}`"
            :value="hospital.id"
            :key="hospital.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择医院" :label-width="formLabelWidth">
        <el-select v-model="editForm.hospital_name" style="width: 240px" allow-create filterable default-first-option
                   placeholder="医院">
          <el-option
            v-for="hospital_name in hospitalColumns"
            :label="hospital_name"
            :value="hospital_name"
            :key="hospital_name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在楼宇" :label-width="formLabelWidth">
        <el-input v-model="editForm.address" style="width: 240px" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="床位号" :label-width="formLabelWidth">
        <el-input v-model="editForm.bed_no" style="width: 240px" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="选择服务" :label-width="formLabelWidth">
        <el-select v-model="editForm.service_id" allow-create filterable default-first-option placeholder="请选择护工"
                   style="width: 240px">
          <el-option
            v-for="nurseService in nurseServicesList"
            :label="`${nurseService.name}/${nurseService.price}`"
            :value="nurseService.id"
            :key="nurseService.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间" :label-width="formLabelWidth">
        <el-date-picker
          v-model="editForm.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间" :label-width="formLabelWidth">
        <el-date-picker
          v-model="editForm.created_at"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label-width="formLabelWidth">
        <div slot="label"><span> </span></div>
        <div style="color: red">{{ allTips }}</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/utils'
import { fetchHospitalPList, fetchNurseList, fetchNurseServicesList, insertOrder, updateOrder } from '../../../api'
import { formatDate } from '../../../utils/date-util'

export default {
  name: 'InsertOrder',
  data() {
    return {
      id: null,
      editForm: {
        time: [new Date()],
        order_id: null,
        hospital_name: '',
        name: '',
        tel: '',
        nurse_id: '',
        service_id: '',
        created_at: '',
        address: '',
        bed_no: ''
      },
      hospitalColumns: [],
      nurseServicesList: [],
      nurses: [],
      formLabelWidth: '153px',
      visible: false
    }
  },
  computed: {
    editFormTitle() {
      return '创建订单'
    },
    allTips() {
      const { service_id, name, time } = this.editForm
      let serviceTimes = null
      let serveName = ''
      if (time && time[0] && time[1]) {
        serviceTimes = (new Date(formatDate(time[1])).getTime() - new Date(formatDate(time[0])).getTime()) / 1000 / 60 / 60 / 24 + 1
      } else {
        return ''
      }
      if (service_id && service_id !== '') {
        const info = this.nurseServicesList.filter(i => i.id === service_id)[0]
        if (info) {
          serveName = `共需要服务${serviceTimes}天，缴费￥${serviceTimes * info.price}`
        }
      }
      return serveName && serveName !== '' && name && name !== '' ? `${name}，${serveName}` : ''
    }
  },
  methods: {
    async getNurseList() {
      const { status, data } = await fetchNurseList()
      if (status) {
        this.nurses = data
      }
    },
    async fetchNurseServicesList() {
      const { status, data } = await fetchNurseServicesList()
      if (status) {
        console.log(data.list)
        this.nurseServicesList = data.list
      }
    },
    async fetchHospital() {
      await fetchHospitalPList().then(res => {
        if (res.status) {
          this.hospitalColumns = [
            ...res.data.list.map(i => {
              return i.hospital_name
            })
          ]
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async handleOpen(info) {
      this.editForm = {
        time: [new Date()],
        hospital_name: '',
        order_id: null,
        name: '',
        tel: '',
        nurse_id: '',
        service_id: '',
        address: '',
        created_at: new Date(),
        bed_no: ''
      }
      if (info) {
        const { id: order_id, nurse_id, start_at, user_name, created_at, hospital_name, user_tel, end_at, service_id, address, bed_no } = info
        this.editForm = {
          order_id,
          time: [new Date(start_at * 1000), new Date(end_at * 1000)],
          created_at: new Date(created_at * 1000),
          hospital_name,
          service_id,
          name: user_name,
          tel: user_tel,
          nurse_id,
          address,
          bed_no
        }
      }
      this.visible = true
      this.getNurseList()
      this.fetchHospital()
      this.fetchNurseServicesList()
    },
    handleSubmit() {
      const {
        hospital_name, time,
        order_id,
        name,
        nurse_id,
        service_id,
        tel,
        address,
        created_at,
        bed_no
      } = this.editForm

      let c = insertOrder
      if (isEmpty(name)) return this.$message({ message: '请输入患者名称', type: 'warning' })
      if (isEmpty(tel)) return this.$message({ message: '请输入患者手机号', type: 'warning' })
      if (isEmpty(nurse_id)) return this.$message({ message: '请选择护工', type: 'warning' })
      if (isEmpty(hospital_name)) return this.$message({ message: '请选择医院', type: 'warning' })
      if (isEmpty(address)) return this.$message({ message: '请输入所在楼宇', type: 'warning' })
      if (isEmpty(bed_no)) return this.$message({ message: '请输入床位号', type: 'warning' })
      if (isEmpty(service_id)) return this.$message({ message: '请选择服务', type: 'warning' })
      if (!(created_at && created_at !== '')) return this.$message({ message: '请选择创建时间', type: 'warning' })
      if (!(time[0] && time[0] !== '' && time[1] && time[1] !== '')) {
        return this.$message({
          message: '请选择时间',
          type: 'warning'
        })
      }
      if (order_id) {
        c = updateOrder
      }

      const params = {
        order_id,
        hospital_name,
        start_at: new Date(formatDate(time[0], 'yyyy-MM-dd 00:00:00')).getTime() / 1000,
        end_at: new Date(formatDate(time[1], 'yyyy-MM-dd 23:59:59')).getTime() / 1000,
        created_at: new Date(created_at).getTime() / 1000,
        name,
        nurse_id,
        service_id,
        tel,
        address,
        bed_no,
        uid: 0
      }
      c(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('success')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
